<app-pick-business *ngIf="isPickBusiness" (onBusinessSelected)="onAction(6,$event)" />
<app-full-page-message
    *ngIf="!isPickBusiness && businessId && businessId.length > 5 && !(localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin) || interactionType == InteractionType.B2B)" />
<div
    *ngIf="!isPickBusiness && (!businessId || businessId.length < 5 || (localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin) || interactionType == InteractionType.B2B))">
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.plan_purchase">
        <div class="banner center" style="max-width:1500px;">
            <div class="row row_header freeze_height" style="border: none;">
                <div class="col-6" style="text-align: left;">
                    <span
                        style="font-weight: normal;">{{localService.languageContent.plan_purchase.one_month_days}}</span>
                </div>
                <div class="col-6" style="text-align: right;">
                    <button type="button" class="btn btn-primary" style="margin:5px;"
                        (click)="onAction(1)">{{localService.languageContent.plan_purchase.buy_plan}}</button>
                </div>
            </div>
            <div class="row row_header freeze_height">
                <div class="col-2">
                    {{localService.languageContent.table.action}}
                </div>
                <div class="col-2">
                    {{localService.languageContent.plan_purchase.inv_sts}}
                </div>
                <div class="col-2">
                    {{localService.languageContent.plan_purchase.inv_nbr}}
                </div>
                <div class="col-2">
                    {{localService.languageContent.plan_purchase.pay_method}}
                </div>
                <div class="col-2">
                    {{localService.languageContent.table.created_on}}
                </div>
                <div class="col-2">
                    {{localService.languageContent.plan_purchase.issued_on}}
                </div>
            </div>
            <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                <div *ngIf="source && source.content">
                    <div class="row styled_row" *ngFor="let item of source.content.items">
                        <div class="col-md-2">
                            <button class="button_icon delete icon_adjust" (click)="onAction(2,item.key)"
                                [disabled]="[PlanPurchaseInvoiceStatus.Cancelled.toString(), PlanPurchaseInvoiceStatus.Activated.toString(),PlanPurchaseInvoiceStatus.Generated.toString(),PlanPurchaseInvoiceStatus.Refunded.toString()].indexOf(item.v1) > -1 ? true: item.v5 == '0'"
                                title="{{localService.languageContent.common.delete}}">
                                add_circle_outline
                            </button>
                            &nbsp;&nbsp;
                            <button class="button_icon button_icon_color icon_adjust" (click)="onAction(3,item.key)"
                                title="{{localService.languageContent.plan_purchase.details}}">
                                account_tree
                            </button>
                            <button class="button_icon button_icon_color icon_adjust" (click)="onAction(4,item.key)"
                                [disabled]="[PlanPurchaseInvoiceStatus.Generated.toString(),PlanPurchaseInvoiceStatus.Refunded.toString()].indexOf(item.v1) <= -1"
                                title="{{localService.languageContent.plan_purchase.receipt}}">
                                receipt
                            </button>
                            <button class="button_icon button_icon_color icon_adjust" (click)="onAction(5,item.key)"
                                [disabled]="[PlanPurchaseInvoiceStatus.Generated.toString(),PlanPurchaseInvoiceStatus.Refunded.toString()].indexOf(item.v1) <= -1"
                                title="{{localService.languageContent.plan_purchase.print}}">
                                print
                            </button>
                            <button class="button_icon button_icon_color icon_adjust"
                                *ngIf="interactionType == InteractionType.Bill_PnixSoft" (click)="onAction(7,item.key)"
                                title="{{localService.languageContent.common.send_to_phone}}"
                                [disabled]="[PlanPurchaseInvoiceStatus.Generated.toString(),PlanPurchaseInvoiceStatus.Refunded.toString()].indexOf(item.v1) <= -1">
                                send_to_mobile
                            </button>
                        </div>
                        <div class="col-md-2">
                            <span>
                                {{localService.getText(source.planPurchaseInvoiceStatuses,item.v1)}}
                            </span>
                        </div>
                        <div class="col-md-2">
                            <span
                                class="en">{{[PlanPurchaseInvoiceStatus.Generated.toString(),PlanPurchaseInvoiceStatus.Refunded.toString()].indexOf(item.v1)
                                > -1 ? item.v3 : '-'}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>
                                {{(!item.v2 || item.v2 == '0') ? '-' :
                                localService.getText(source.deductionMethods,item.v2)}}
                            </span>
                        </div>
                        <div class="col-md-2">
                            <span class="en">
                                {{item.v6 | date : 'dd-MMM-yyyy hh:mm a'}}
                            </span>
                        </div>
                        <div class="col-md-2">
                            <span class="en" *ngIf="item.v4.length > 0">
                                {{item.v4 | date : 'dd-MMM-yyyy hh:mm a'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-paging *ngIf="source && source.content && source.content.paging" [paging]="source.content.paging"
            (onPagingRefreshed)="onLoad()"></app-paging>
        <app-print *ngIf="IsPrint" [fileName]="fileName" [content]="printContent" (onPrinted)="onPrinted()"></app-print>
    </div>
    <div>
        <app-send-to-phone *ngIf="isOpenSendToPhone" [(isOpen)]="isOpenSendToPhone" [key]="selectedId"
            [communicationTemplate]="CommunicationTemplate.InvoiceGenerated" />
    </div>
</div>